export const DATETIMES = {
    date:'YYYY-MM-DD',
    time:'hh:mm:ss A',
    time24h:'HH:mm:ss',
}